export default "__VITE_ASSET__AYe3WcHn__"